export default (function (){

    const defaults = {
        selectors: {
            element: ".siteNav",
            toggle: ".siteNav-toggle",
        },
    };

    function init(options) {

        options = options || {};

        const settings = Object.assign({}, defaults, options),
              elements = document.querySelectorAll(settings.selectors.element);

        elements.forEach((element) => {
            new Navigation(element, settings);
        });

    }

    const Navigation = function(container, settings) {

        this.container = container;
        this.settings = Object.assign({}, settings);

        const toggles = this.container.querySelectorAll(settings.selectors.toggle);

        toggles.forEach((toggle) => {

            let clickHandler = () => { this.open() };

            if (toggle.dataset.action === "close") {
                clickHandler = () => { this.close(); }
            }

            toggle.addEventListener("click", () => {
                clickHandler();
            });

        });

        const links = this.container.querySelectorAll("a");

        links.forEach((link) => {

            link.addEventListener("click", () => {
                this.close();
            });

        });

        this.container.addEventListener("focusout", () => {

            setTimeout(() => {

                if (this.container.contains(document.activeElement)) {
                    return;
                }

                this.close();

            }, 100);

        });

    }

    Navigation.prototype.open = function() {
        this.container.dataset.visible = "true";
    }

    Navigation.prototype.close = function() {
        this.container.dataset.visible = "false";
    }

    return {
        init: init,
    }

})();
